var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(_vm.loading)?_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"article"}}):_c('div',{staticStyle:{"position":"fixed","top":"48px","left":"0","right":"0","bottom":"0"},attrs:{"id":"TalkMe-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }